// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"324":"f1f0187e","373":"fb05e07c","526":"e9a0876a","887":"9b130496"}[chunkId] + ".css";
};